export default {
    DEMO_USERNAME: 'FR',
    DEMO_PASSWORD: '',
    DEMO_LICENSE_KEY: 'DEV-EMWORK'
}